import React, { useState } from 'react';
import { Button, Card } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';
import './GroupChange.scss';
const { submitGroupChangeRequest } = useAPI();

export default class GroupChange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            get: [],
            type: [],
            post: [],
            submit: ''
        };
        this.submitGroupChangeRequests = this.submitGroupChangeRequests.bind(this);
    }

    getResponse(data) {
        // console.log(data);
        this.setState({
            get: data
        });
    }

    typeResponse(data) {
        this.setState({
            type: data
        });
    }

    submitGroupChangeRequests() {
        // console.log('submitting complaint');
        var desiredgroup = document.getElementById('desiredgroup').value;
        var reason = document.getElementById('reason').value;
       
        submitGroupChangeRequest(desiredgroup, reason).then((data) => {
            this.setState({ loading: true }); // Set loading to true before the request
        
            submitGroupChangeRequest(desiredgroup, reason)
                .then((data) => {
                    this.setState({
                        post: data,
                        loading: false, // Stop the loader after the request is completed
                    });
        
                    if (this.state.post.result === true) {
                        alert("Request submitted successfully");
                        document.getElementById(
                            'status'
                        ).innerHTML = `<div class='successmsg mt-2 mb-2'>Request submitted successfully</div>`;
                    }
                })
                .catch((error) => {
                    this.setState({ loading: false }); // Stop the loader in case of an error
                    console.error(error);
                });
        });
    }

    componentDidMount() {
        const { getProfile } = useAPI();
        getProfile()
            .then((response) => this.getResponse(response))
            .catch((error) => console.error(error));       
    }

    render() {
        const { get, type, post } = this.state;
        // console.log(post);
        const FirstTab = () => {
            // Add the desired group options here
            const type = [
                { id: "1", name: "SR-SHIKHAR-1" },
                { id: "2", name: "JR-SHIKHAR-1" },
                { id: "3", name: "JR-SHIKHAR-2" },
                { id: "4", name: "SR-AMOGH" },
                { id: "5", name: "SR-LAKSHYA-1" },
                { id: "6", name: "SR-JIGNYASA-1" },
                { id: "7", name: "JR-JIGNYASA-1" },
                { id: "8", name: "SR-SHIKHAR-2" },
                { id: "9", name: "JR-LAKSHYA-1" },
                { id: "10", name: "JR-INT-MEC" },
                { id: "11", name: "JR-SHOURYA" },
                { id: "12", name: "SR-MEC" },
                { id: "13", name: "SR-M-SHIKHAR" },
                { id: "14", name: "SR-BiPC" },
                { id: "15", name: "JR-AMOGH" },
                { id: "16", name: "JR-BiPC-1" },
                { id: "17", name: "JR-BiPC-2" },
                { id: "18", name: "JR-LAKSHYA-2" },
                { id: "19", name: "SR-JIGNYASA-2" },
                { id: "20", name: "JR-JIGNYASA-2" },
                { id: "21", name: "SR-LAKSHYA-2" },
                { id: "22", name: "JR-VAIDYA" },
                { id: "23", name: "JR-SRUJAN" },
            ];
            const updatedType = type.map((item) => ({
                id: item.name, // Replace id with the name value
                name: item.name,
            }));
            // Filter groups starting with "JR" and "SR"
const type1 = updatedType.filter((group) => group.name.startsWith("JR")); // Groups starting with JR
const type2 = updatedType.filter((group) => group.name.startsWith("SR")); // Groups starting with SR
const currentYear = get.currentyear; // Assume this is the current year value
const filteredType = currentYear === '1' ? type1 : type2;
        
            return (
                <div className="FirstTab">
                    <Card
                        title="Desired Group"
                        body={
                            <select
                                id="desiredgroup"
                                className="form-control mb-1"
                            >
                                 {filteredType.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <Card
                        title="Please write reason to change"
                        body={
                            <div>
                                <textarea
                                    id="reason"
                                    className="form-control mt-2 mb-2"
                                    rows="14"
                                    name="reason"
                                ></textarea>
                                <Button
                                    type="submit"
                                    onClick={this.submitGroupChangeRequests}
                                    className="groupchangesubmit mb-2"
                                    color="blue"
                                >
                                    Submit
                                </Button>
                                <div>
                                    {this.state.loading ? (
                                        <div className="loader">Loading...</div> // Add a loader div or component
                                    ) : (
                                        <div id="status"></div>
                                    )}
                                </div>
                            </div>
                        }
                    />
                </div>
            );
        };
        
       
        

 
        const Tabs = () => {
            const [activeTab, setActiveTab] = useState('tab1');
            const handleTab1 = () => {
                setActiveTab('tab1');
            };
         
            return (
                <div className="Tabs">
                    <ul className="navtab">
                        <li
                            style={{ justifyContent: 'center' }}
                            className={activeTab === 'tab1' ? 'active' : ''}
                            onClick={handleTab1}
                        >
                            
                            <div>Active Group</div>
                        </li>
                        <li>
                          
                            <div>{get.dept}-{get.section}</div>
                        </li>
                    </ul>
                    <div className="outlet">
                        <FirstTab /> 
                    </div>
                </div>
            );
        };

        return (
            <div className="container">
                <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Group Change Request</div>
                </div>
                <Tabs></Tabs>
            </div>
        );
    }
}